import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { OneWayInOpportunityCreateDto, OneWayInService } from 'src/api/v2';
import {
  ONE_WAY_IN_ACTORS_WITH_ACCESS,
  ONE_WAY_IN_ALL_FORMS_KEY,
  ONE_WAY_IN_ALL_SAVED_FORMS_KEY,
  ONE_WAY_IN_OPPORTUNITY_BY_ID,
} from 'src/constants/hook-keys';

const useCreateOpportunity = () => {
  const [service] = useState(() => new OneWayInService());
  const queryClient = useQueryClient();

  const createOpportunity = useMutation({
    mutationFn: (createDto: OneWayInOpportunityCreateDto) =>
      service
        .createOneWayInOpportunity(createDto)
        .then((data) => queryClient.setQueryData([ONE_WAY_IN_OPPORTUNITY_BY_ID, createDto.oneWayInId], data)),
    retry: false,
    onSuccess: (_data, createDto) => {
      queryClient.invalidateQueries([ONE_WAY_IN_ALL_FORMS_KEY]);
      queryClient.invalidateQueries([ONE_WAY_IN_ALL_SAVED_FORMS_KEY]);
      queryClient.invalidateQueries([ONE_WAY_IN_ACTORS_WITH_ACCESS, createDto.oneWayInId]);
    },
  });

  return { createOpportunity };
};

export default useCreateOpportunity;
